import {
  NumberedListBlock,
  createNumberItem,
} from 'Event/Marketplace/Block/NumberedList'
import {uuid} from 'lib/uuid'

const defaultItems = {
  [uuid()]: createNumberItem(),
}

export const createNumberedListBlock = (): NumberedListBlock => ({
  type: 'NumberedList',
  visibility: 'all',
  background: {
    image: '',
    color: '',
    opacity: 0,
  },
  padding: {
    top: 10,
    right: 10,
    bottom: 10,
    left: 10,
  },
  alignment: {
    vertical: 'start',
    horizontal: 'left',
  },
  border: {
    width: 0,
    color: '#FFFFFF',
    radius: 0,
  },
  font: null,
  fontSize: 24,
  color: '#3490DC',
  numberSpace: 10,
  textSpace: 10,
  items: defaultItems,
  counter: {
    style: 'numeric',
    outline: 'none',
    font: null,
    fontSize: 24,
    color: '#3490DC',
    background: {
      color: '',
      opacity: 0,
    },
  },
})
